import {
  requestObituary,
  requestObituaryMemberSetting,
  requestSaveObituaryMemberSetting,
  requestObituaryMsgSend,
  requestObituaryMsgPwdCheck,
  requestAccountMsgSend,
  requestObituaryOnlySend,
  requestAccountCertify,
  requestObituarAgree
} from "@/apis/obituary_api";

const state = {
  obituary: null
};

const getters = {
  getObituary(state) {
    return state.obituary;
  }
};

const mutations = {
  SET_OBITUARY(state, obituary) {
    state.obituary = obituary;
  }
};

const actions = {
  // 부고장 조회
  async REQUEST_OBITUARY_INFO({ commit }, params) {
    try {
      const response = await requestObituary(params);
      const { data } = response;

      if (data.result === "fail") {
        return null;
      }
      commit("SET_OBITUARY", data);

      return data;
    } catch (error) {
      console.error(error);
      return false;
    }
  },
  async REQUEST_OBITUARY_MSG_SEND({ commit }, parameter) {
    try {
      commit("START_LOADING");
      const response = await requestObituaryMsgSend(parameter);

      const { data } = response;

      if (data?.result === "success") {
        return data;
      }
    } catch (e) {
      console.error(e);
    } finally {
      commit("END_LOADING");
    }
  },

  async REQUEST_OBITUARY_ONLY_SEND({ commit }, parameter) {
    try {
      commit("START_LOADING");
      const response = await requestObituaryOnlySend(parameter);
      const { data } = response;
      if (data?.result !== "success") {
        return alert(data.message);
      }

      alert("발송을 완료하였습니다.");
    } catch (e) {
      if (e === "refresh") {
        return;
      }
      console.error(e);
    } finally {
      commit("END_LOADING");
    }
  },

  // 추모 메시지 비밀번호 확인
  async REQUEST_OBITUARY_MSG_PWD_CHECK(_, params) {
    try {
      const result = await requestObituaryMsgPwdCheck(params);

      if (result) {
        return result;
      }

      return false;
    } catch (error) {
      console.error(error);
      return false;
    }
  },

  async REQUEST_ACCOUNT_MSG_SEND({ commit }, parameter) {
    try {
      commit("START_LOADING");
      const response = await requestAccountMsgSend(parameter);

      const { data } = response;

      if (data?.result === "success") {
        return data;
      }
    } catch (e) {
      console.error(e);
    } finally {
      commit("END_LOADING");
    }
  },

  // 부고장 설정 페이지 접속 시 상주 조회
  async REQUEST_OBITUARY_MEMBER_SETTING({ commit }, memberId) {
    try {
      commit("START_LOADING");
      const response = await requestObituaryMemberSetting(memberId);

      const { data } = response;

      if (data?.result === "success") {
        return data;
      }

      return null;
    } catch (e) {
      console.error(e);
    } finally {
      commit("END_LOADING");
    }
  },

  // 부고장 설정 저장
  async REQUEST_SAVE_OBITUARY_MEMBER_SETTING({ commit }, parameter) {
    try {
      commit("START_LOADING");
      const response = await requestSaveObituaryMemberSetting(parameter);

      const { data } = response;

      if (data?.result === "success") {
        return data;
      }

      return null;
    } catch (e) {
      console.error(e);
    } finally {
      commit("END_LOADING");
    }
  },

  // 계좌 인증
  async REQUEST_ACCOUNT_CERTIFY({ commit }, parameter) {
    let param = {};
    try {
      commit("START_LOADING");
      const response = await requestAccountCertify(parameter);
      const { data } = response;
      if (data?.result !== "success") {
        param.result = false;
        return param;
      }
      if (data.accountInfo.result === 100) {
        param.result = true;
        param.name = data.accountInfo.accountName;
      } else {
        param.result = false;
      }

      commit("END_LOADING");
    } catch (e) {
      if (e === "refresh") {
        return;
      }
      console.error(e);
      param.result = false;
    } finally {
      commit("END_LOADING");
    }
    return param;
  },

  // 개인정보 동의
  async REQUEST_OBITUARY_AGREE({ commit }, params) {
    try {
      commit("START_LOADING");
      const result = await requestObituarAgree(params);

      if (result) {
        return result;
      }

      return false;
    } catch (e) {
      if (e === "refresh") {
        return false;
      }
      console.error(e);
      return false;
    } finally {
      commit("END_LOADING");
    }
  }
};

export default { mutations, state, actions, getters };
